import {createSlotRecipeContext} from '@chakra-ui/react3'
import heroSlotRecipe from './index.recipe'

/**
 * Context provider and hook for Hero component styles.
 * Uses the heroSlotRecipe to manage styles for Hero's slots.
 */
const {StylesProvider, useStyles} = createSlotRecipeContext({
    recipe: heroSlotRecipe
})

export {StylesProvider, useStyles}
